export default __webpack_public_path__ + "static/media/wdg-img-1.37c2de68.jpg";